import { lazy } from 'react';

// project import
import Loadable from '../components/Loadable';
import MainLayout from '../layout/MainLayout';
import { PrivateRoute } from '../routes/PrivateRoute';
import { element } from 'prop-types';
//import CreatePmi from './../pages/siteManagement/createPmi';

// render - dashboard
const DashboardDefault = Loadable(lazy(() => import('./../pages/dashboard')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('./../pages/extra-pages/SamplePage')));

// render - utilities
const Typography = Loadable(lazy(() => import('./../pages/components-overview/Typography')));
const Color = Loadable(lazy(() => import('./../pages/components-overview/Color')));
const Shadow = Loadable(lazy(() => import('./../pages/components-overview/Shadow')));
const AntIcons = Loadable(lazy(() => import('./../pages/components-overview/AntIcons')));

const DefaultPage = Loadable(lazy(() => import('./../pages/extra-pages/default')));
const CreateSite = Loadable(lazy(()=> import( './../pages/siteManagement/createSite')));
const SiteDetailsView= Loadable(lazy(()=>import('../pages/siteManagement/siteDetailsView')))
const PMADefaultPage = Loadable(lazy(() => import('./../pages/propertyManager/default')));
//const createPMA = Loadable(lazy(() => import('./../pages/siteManagement/createPmi')));
const DetailsPMA = Loadable(lazy(() => import('./../pages/propertyManager/detailsPMA')));
const CustomerAccountDefaultPage = Loadable(lazy(() => import('./../pages/customerManagement/default')));
const CustomerAccountCreate = Loadable(lazy(() => import('./../pages/customerManagement/createCA')));
const CustomerAccountDetails = Loadable(lazy(() => import('./../pages/customerManagement/detailsCA')));
const CAMDefaultPage = Loadable(lazy(() => import('./../pages/camManager/default')));
//const createPMA = Loadable(lazy(() => import('./../pages/siteManagement/createPmi')));
const CreateCAM = Loadable(lazy(() => import('./../pages/camManager/createCAM')));
const DetailsCAM = Loadable(lazy(() => import('./../pages/camManager/detailsCAM')));





// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [

    {
      path: '/',
      element: <PrivateRoute><DefaultPage /></PrivateRoute>
    },
    {
      path: 'default',
      element: <PrivateRoute><DefaultPage /></PrivateRoute>,
     
    },
    {
      path: 'default/createSite',
      element: <PrivateRoute><CreateSite /></PrivateRoute>
    },
    {
      path: 'default/SiteDetails',
      element: <PrivateRoute><SiteDetailsView /></PrivateRoute>
    },
    {
      path: 'PropertyManager',
      element: <PrivateRoute><PMADefaultPage /></PrivateRoute>
    },
    {

      path:'PropertyManager/detailsPMA',
      element:<PrivateRoute><DetailsPMA propertymanageropen='true' viewedit='true' viewdetails='false' /></PrivateRoute>
    },

    {
      path: 'CustomerAccount',
      element: <PrivateRoute><CustomerAccountDefaultPage /></PrivateRoute>
    },
    {
      path: 'CustomerAccount/Create',
      element: <PrivateRoute><CustomerAccountCreate /></PrivateRoute>
    },
    {
      path:'CustomerAccount/Details',
      element: <PrivateRoute><CustomerAccountDetails propertymanageropen='true' viewedit='true' viewdetails='false' /></PrivateRoute>
    },
    {
      path: 'AdminUserManager',
      element: <PrivateRoute><CAMDefaultPage /></PrivateRoute>
    },
    {
      path: 'AdminUserManager/createCAM',
      element: <PrivateRoute><CreateCAM propertymanageropen='true' viewedit='true' viewdetails='false' /></PrivateRoute>
    },
    {

      path:'AdminUserManager/detailsCAM',
      element:<PrivateRoute><DetailsCAM propertymanageropen='true' viewedit='true' viewdetails='false' /></PrivateRoute>
    }
  ]
};

export default MainRoutes;
